import { RouteName } from 'src/app/core/enums/RouteName';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { defer, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LoaderService } from 'src/app/core/loader-services/loader.service';
import { Router } from '@angular/router';
import { ChannelService } from 'src/app/home/channel/channel.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService {

  activeRequests: number = 0;

  /**
   * URLs for which the loading screen should not be enabled
   */
   skippUrls = [
    '/dynamicqr',
  ];

  constructor(
    private loadingScreenService: LoaderService,
    private router: Router,
    private channelService : ChannelService,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let currentRoute = this.channelService.getCurrentRouteName();
    let displayLoadingScreen = true;

    if (request.url.includes(environment.apis.order.GetActivitySummary) || request.url.includes(environment.apis.user.UpdateChatId) ||
      request.url.includes(environment.apis.voucher.GetNearbyVoucherType) || request.url.includes(environment.apis.voucher.GetCustomerClaimedVoucher) ||
      request.url.includes(environment.apis.voucher.GetVoucherTypeCategories) || request.url.includes(environment.apis.voucher.GetCustomerVoucherHistory) ||
      request.url.includes(environment.apis.channel.GetChannelHomeSection) || request.url.includes(environment.apis.review.GetStoreReviewData) ||
      (currentRoute == RouteName.OrderSummary && (request.url.includes(environment.apis.order.GetOrderSummary) ||
      request.url.includes(environment.apis.order.GetActivityByLinkId) || request.url.includes(environment.apis.order.GetActivityByOrders) ||
      request.url.includes(environment.apis.order.GetActivityByRsvTokenId))) ||
      (currentRoute == RouteName.OrderDetail && (request.url.includes(environment.apis.order.GetActivityDetail))) ||
      request.url.includes(environment.apis.membership.GetCustomerMemberships) || request.url.includes(environment.apis.membership.GetMembershipRewardHistory)
      || currentRoute == RouteName.App || (currentRoute == RouteName.Queue && request.url.includes(environment.apis.queue.GetQueueByToken) || request.url.includes(environment.apis.messenger.GetMessageStatus))
      ) {
      displayLoadingScreen = false;
    }

    for (const skippUrl of this.skippUrls) {
      if (new RegExp(skippUrl).test(this.router.url)) {
        displayLoadingScreen = false;
        break;
      }
    }

    if (displayLoadingScreen) {
      return defer(() => {
        const release = this.loadingScreenService.acquire();
        this.activeRequests++;
        return defer(() => next.handle(request)).pipe(finalize(() => {
          this.activeRequests--;
          release();
        }));
      });
    } else {
      return next.handle(request);
    }
  };
}
